import type {
  EntityTypeColorMap,
  ModuleColorMap,
  StatusColorMap,
} from '../types/colorConfig';

export const DEFAULT_MODULE_COLORS: ModuleColorMap = {
  trade: 'primary',
  transportation: 'teal',
  production: 'purple',
  compliance: 'warning',
  finance: 'success',
  inventory: 'brown',
};

export const DEFAULT_ENTITY_TYPE_COLORS: EntityTypeColorMap = {
  booking: 'primary',
  load: 'teal',
  salesOrder: 'success',
  route: 'purple',
  driverCertification: 'warning',
  workOrder: 'magenta',
  inboundTolling: 'olive',
  outboundTolling: 'rust',
  dispatchRecord: 'slate',
  invoice: 'brown',
  bill: 'failure',
  inventoryMovement: 'neutral',
};

export const DEFAULT_STATUS_COLORS: StatusColorMap = {
  active: 'success',
  completed: 'primary',
  pending: 'warning',
  overdue: 'failure',
};
